export function TmxLogo(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 37 42"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M34.7502 13.9137H31.5423C32.1122 11.6075 32.4156 9.1962 32.4156 6.71387L30.4046 7.51865C30.0369 20.4956 20.7996 31.2551 8.54072 33.9478L8.2832 34.7236C13.7119 33.6158 18.579 30.9694 22.411 27.2595H24.7456L27.8143 22.8558L30.8821 27.2595H34.7502L29.6403 20.5894"
        fill="currentColor"
      />
      <path
        d="M26.9763 18.4372L25.3889 16.3209H22.7209L25.9 20.4653C26.3127 19.8561 26.7071 19.1294 26.9763 18.4372Z"
        fill="currentColor"
      />
      <path
        d="M2.93237 16.3074H10.7757V17.3835H8.15306V24.683L5.72812 25.2149V17.3835H3.18002"
        fill="currentColor"
      />
      <path
        d="M13.3362 18.856L16.2312 25.017V25.0049L19.0892 18.8684V24.9872H21.5014V16.3199H19.0765L16.9242 20.9713L14.8084 16.3199H12.149V24.9872H13.3362"
        fill="currentColor"
      />
    </svg>
  )
}
